module.exports = __webpack_public_path__ + "img/thumbnail_SpectacledBear_f_normal.48955200.png";